<template>
  <div>
    <vx-card>
      <template v-if="beneficiaries > 0">
        <div class="vx-row">
          <div class="vx-col w-full md:w-2/3" >
            <h4>¿Quiénes son tus beneficiarios?</h4>
            <p class="mb-2 mt-2">
              Consulta y administra los datos e información más relevante de tus beneficiarios.
              Procura mantener este apartado lo más actualizado posible.
            </p>
          </div>
        </div>
      </template>
      <template v-else >
        <div>
          <h4>No tienes beneficiarios registrados</h4>
          <p class="mt-2 mb-2">Podrás regresar cuando lo desees, para administrar los registros que existan.</p>
        </div>
      </template>

      <beneficiaries-list
        v-if="UserId"
        @loadedBeneficiaries="loadedBeneficiaries"
        @on-show-request="onShowRequest"
        :user-id="UserId"
        role="investor"
      />
    </vx-card>

    <vs-popup class="extended-popup" title="Datos de beneficiario" :active.sync="isBeneficiaryDetailPopupActive" v-if="isBeneficiaryDetailPopupActive">
      <beneficiary-detail :id="showBeneficiaryId" />
    </vs-popup>
  </div>

</template>

<script>
import BeneficiariesList from "@components/profile_shared/BeneficiariesList";
import BeneficiaryDetail from "@components/profile_shared/BeneficiaryDetail";
import investorInfoHelper from "@/helpers/investorInfoHelper";
export default {
  name: "InvestorBeneficiaries",
  data() {
    return {
      beneficiaries: null,
      newRecord: true,
      editBeneficiaryId: null,
      showBeneficiaryId: null,
      InvestorId: null,
      UserId: null,
    }
  },
  mixins: [investorInfoHelper],
  components: {
    BeneficiariesList,
    BeneficiaryDetail
  },
  computed: {
    isBeneficiaryDetailPopupActive: {
      get() {
        return this.$store.state.isBeneficiaryDetailPopupActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_BENEFICIARY_DETAIL_POPUP_ACTIVE", val);
      }
    },
  },
  async beforeMount(){
    await this.getInvestorInfo();
  },
  methods: {
    async getInvestorInfo(){
      this.InvestorId = this.$route.params.id;
      const requiredObjects = ['user'];
      const investor = await this.getInvestorData(this.InvestorId, requiredObjects);
      this.UserId = investor.user.id;
    },
    loadedBeneficiaries(count) {
      this.beneficiaries = count;
    },
    onShowRequest(id){
      this.showBeneficiaryId = id;
      this.isBeneficiaryDetailPopupActive = true;
    },
  }
}
</script>

<style scoped>

</style>